<template>
  <HubContainer id="globalSupportDebugHub">

    <HubSection large icon="icon/hub/failed-sales.svg" v-if="atLeastSuperAdmin"
                :title="$t('advanced_navigation.failed_sales')"
                :description="$t('advanced_navigation.failed_sales_description')"
                :buttonAction="goToFailedSales">
    </HubSection>

    <HubSection large icon="icon/hub/change-logs.svg"
                :title="$t('advanced_navigation.company_change_log')"
                :description="$t('advanced_navigation.company_change_log_description')"
                :buttonAction="goToChangeLogs">
    </HubSection>

  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "globalSupportDebugHub",

    components: {HubSection, HubContainer},

    mounted() {
      this.$store.state.pageTitleTranslationKey = "advanced_navigation.global_support_debug";
      this.$store.state.pageIcon = "/icon/nav/bug.svg";
    },

    computed: {
      atLeastSuperAdmin() {
        return this.$store.getters.loggedUserHasSuperAdmin;
      },
    },

    methods: {
      goToFailedSales() {
        this.$router.push(this.$router.buildContext("/failed-sales"));
      },
      goToChangeLogs() {
        this.$router.push(this.$router.buildContext("/company-change-log"));
      }
    }
  }
</script>